import types from './types';
import API from '../../lib/api';
import {toast} from 'react-toastify';
import globalTypes from '../types';
import ModalsLib from '../../lib/modals';

export const getWheelState = () => async dispatch => {
    const response = await API.call({
        path: '/modules/lucky_wheel/initialize'
    });

    if(response.success)
        dispatch({
            type: types.loaded,
            payload: {
                sectors: response.data.sectors,
                rewards: response.data.rewards,
                prize: response.data.prize,
                rotate: response.data.rotate,
                timeout: Date.now() + response.data.timeout
            }
        });
}

export const toggleWheel = () => {
    return {
        type: types.opened
    }
}

export const makeSpin = () => async dispatch => {
    dispatch({
        type: types.wheel.toggleButton
    });

    const response = await API.call({
        path: '/modules/lucky_wheel/spin'
    });

    if(response.success) {
        dispatch({
            type: types.wheel.update,
            payload: {
                status: "spin",
                rotate: response.data.animation.spin,
                button: false
            }
        });

        dispatch({
            type: types.timeout,
            payload: response.data.timeout + Date.now()
        });

        setTimeout(() => {
            dispatch({
                type: types.wheel.update,
                payload: {
                    status: "spin-finale",
                    rotate: response.data.animation.spin_finale,
                }
            });

            setTimeout(() => {
                dispatch({
                    type: types.wheel.update,
                    payload: {
                        status: "none",
                        rotate: response.data.animation.spin_reset,
                    }
                });

                dispatch({
                    type: types.prize,
                    payload: response.data.prize
                });

                // Prize

                // window.alert(`Prize show`);
            }, 1e3);
        }, 5e3);
    } else {
        toast.dismiss();
        toast.error(response.error);

        dispatch({
            type: types.wheel.toggleButton
        });
    }
}

export const claimPrize = (id, game = null) => async dispatch => {
    dispatch({
        type: types.togglePrizeButton
    });

    const response = await API.call({
        path: '/modules/lucky_wheel/redeem',
        body: {
            id,
            game
        }
    });

    if(response.success) {
        if(typeof response.data.message !== 'undefined') {
            toast.dismiss();
            toast.success(response.data.message);
        }

        if(response.data.bonus === 'deposit_boost') {
            dispatch({
                type: globalTypes.user.deposit_bonus,
                payload: response.data.deposit_bonus
            });

            ModalsLib.open('wallet');
        } else if(response.data.bonus === 'diamonds') {
            dispatch({
                type: globalTypes.user.balance,
                payload: response.data.balance
            });
        } else if(response.data.bonus === "cash") {
            dispatch({
                type: globalTypes.user.balance,
                payload: response.data.balance
            });   
        } else if(response.data.bonus === "freeplay") {
            dispatch({
                type: globalTypes.games.history.add,
                payload: response.data.transaction
            });
        }

        dispatch({
            type: types.prize,
            payload: null
        });

        setTimeout(() => {
            dispatch({
                type: types.opened
            });

            dispatch({
                type: types.togglePrizeButton
            });
        }, 1e3);
    } else {
        dispatch({
            type: types.togglePrizeButton
        });

        toast.dismiss();
        toast.error(response.error);
    }
}

// export const spin = () => dispatch => {
//     dispatch({
//         type: types.spin,
//         payload: {
//             status: "spin",
//             rotate: 3379
//         }
//     });

//     setTimeout(() => {
//         dispatch({
//             type: types.spin,
//             payload: {
//                 status: "spin-finale",
//                 rotate: 3360
//             }
//         });

//         setTimeout(() => {
//             dispatch({
//                 type: types.spin,
//                 payload: {
//                     status: "none",
//                     rotate: 120
//                 }
//             });
//         }, 3e3);
//     }, 5e3);
// }